import React, { Component } from "react"
import PropTypes from "prop-types"
import { Input, Form, Icon, Button, Pagination } from "semantic-ui-react"
import _ from "lodash"
import "style/Pagination.scss"
import shop from "shop/shop"

export default class ShopPagination extends Component {

  static propTypes = {
    filter:   PropTypes.object,
    onChange: PropTypes.func,
    showNav:  PropTypes.bool,
  }

  render() {
    let { filter } = this.props
    let nPages = this.nPages( filter )
    if ( nPages <= 1 ) return null
    return (
      <div className="pagination-wrapper">
        <div className={"black-60 pb1"}><label htmlFor="">  {translate( "pagination.pages", { current: filter.currentPage, total: nPages } )}</label></div>
        <Pagination pointing
                    siblingRange={0}
                    secondary
                    boundaryRange={0}
                    activePage={filter.currentPage} size="small"
                    onPageChange={this.handlePageSelect}
                    totalPages={nPages}
        />
      </div>
    )
  }

  handleFocus( event ) {
    event.target.select()
  }

  handlePageSelect = ( e, data ) => {
    const { activePage } = data
    this.setPage( activePage )
  }

  setPage( page ) {
    let { filter, onChange } = this.props
    page = Number( page )
    if ( _.isNumber( page ) && page >= 0 && page <= this.nPages( filter ) ) {
      if ( page !== filter.currentPage ) onChange( page )
    }
  }

  nPages( filter ) {
    let nPages = Math.ceil( (filter.total) / (filter.pageSize) )
    return nPages
  }

  nextPage = () => {
    let { filter, onChange } = this.props
    let nPages = this.nPages( filter )
    let page = Math.min( nPages, filter.currentPage + 1 )
    if ( page !== filter.currentPage ) onChange( page )
  }

  prevPage = () => {
    let { filter, onChange } = this.props
    let page = Math.max( 1, filter.currentPage - 1 )
    if ( page !== filter.currentPage ) onChange( page )
  }
}




// WEBPACK FOOTER //
// ./src/components/Pagination/Pagination.js